import { jsx as _jsx } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
const SubjectList = (param)=>{
    let { items , selectedId , onItemClick , className , variant ="default"  } = param;
    const handleItemClick = (item)=>{
        mixpanelEvent("Category Board Item Clicked", {
            "Item Type": "Menu",
            "Item Name": item.menuTitle
        });
        onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(item);
    };
    return /*#__PURE__*/ _jsx("div", {
        className: cn("w-full py-2.5", className),
        children: items.map((item)=>{
            const isSelected = selectedId === item.id;
            return /*#__PURE__*/ _jsx("button", {
                type: "button",
                onClick: ()=>handleItemClick(item),
                className: cn("w-full px-4 py-2 text-left transition-all", variant === "mobile" ? "typo-subtitle1" : "typo-h6", isSelected ? "text-strong bg-white" : "text-secondary hover:text-strong"),
                children: item.menuTitle
            }, item.id);
        })
    });
};
export default SubjectList;
